import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-insurance-authority',
  templateUrl: './insurance-authority.component.html',
  styleUrls: ['./insurance-authority.component.css']
})
export class InsuranceAuthorityComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
